const testCpf = (cpf) => {
  const errorMessages = {
    messages: [
      {
        text: 'O número de CPF informado não é válido. Por favor, verifique se você digitou direitinho e tente novamente.',
        type: 'message-long-error-icon'
      }
    ]
  };
  if (cpf.length !== 11) throw errorMessages;
};

export const cpfValidator = (cpf) => {
  try {
    testCpf(cpf);
    return {status: true, partnerCpf: cpf};
  } catch (error) {
    return {status: false, partnerCpf: '', error};
  }
};
